import {Component, Input, ElementRef} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {AppService} from '../../../../shared/services/app-service'; // TODO: Decouple

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:ProductDetailsCmp'));

@Component({
    selector: 'product-details-cmp',
    template: require('./product-details.cmp.html'),
    styles: [String(require('./product-details.cmp.scss'))],
    host: { class: 'product-details' }
})
export class ProductDetailsCmp {

    private _imgPaths = null;
    private _productElem = null;

    constructor(
        private _elementRef: ElementRef,
        private _catalogService: CatalogService,
        private _appService: AppService
    ) {
        // 'Construct product details component' );

        this._imgPaths = this._catalogService.imgPaths;
        this._productElem = _elementRef.nativeElement;
    }

    
    ngOnInit() {
        // 'Initialise product details component' );
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/products/product-details.cmp.ts